import { defineComponent as S, ref as c, provide as k, computed as b, onMounted as C, onUnmounted as B, watchEffect as j, inject as $ } from "vue";
import { useId as P } from "./index327.js";
import { useResolveButtonType as M } from "./index329.js";
import { useOpenClosedProvider as H, useOpenClosed as L, State as D } from "./index333.js";
import { Keys as v } from "./index334.js";
import { dom as d } from "./index339.js";
import { match as I } from "./index342.js";
import { render as g, Features as h } from "./index345.js";
var N = ((l) => (l[l.Open = 0] = "Open", l[l.Closed = 1] = "Closed", l))(N || {});
let w = Symbol("DisclosureContext");
function O(l) {
  let u = $(w, null);
  if (u === null) {
    let r = new Error(`<${l} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, O), r;
  }
  return u;
}
let E = Symbol("DisclosurePanelContext");
function R() {
  return $(E, null);
}
let J = S({ name: "Disclosure", props: { as: { type: [Object, String], default: "template" }, defaultOpen: { type: [Boolean], default: !1 } }, setup(l, { slots: u, attrs: r }) {
  let o = c(l.defaultOpen ? 0 : 1), e = c(null), i = c(null), a = { buttonId: c(`headlessui-disclosure-button-${P()}`), panelId: c(`headlessui-disclosure-panel-${P()}`), disclosureState: o, panel: e, button: i, toggleDisclosure() {
    o.value = I(o.value, { 0: 1, 1: 0 });
  }, closeDisclosure() {
    o.value !== 1 && (o.value = 1);
  }, close(t) {
    a.closeDisclosure();
    let n = t ? t instanceof HTMLElement ? t : t.value instanceof HTMLElement ? d(t) : d(a.button) : d(a.button);
    n?.focus();
  } };
  return k(w, a), H(b(() => I(o.value, { 0: D.Open, 1: D.Closed }))), () => {
    let { defaultOpen: t, ...n } = l, p = { open: o.value === 0, close: a.close };
    return g({ theirProps: n, ourProps: {}, slot: p, slots: u, attrs: r, name: "Disclosure" });
  };
} }), W = S({ name: "DisclosureButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(l, { attrs: u, slots: r, expose: o }) {
  let e = O("DisclosureButton"), i = R(), a = b(() => i === null ? !1 : i.value === e.panelId.value);
  C(() => {
    a.value || l.id !== null && (e.buttonId.value = l.id);
  }), B(() => {
    a.value || (e.buttonId.value = null);
  });
  let t = c(null);
  o({ el: t, $el: t }), a.value || j(() => {
    e.button.value = t.value;
  });
  let n = M(b(() => ({ as: l.as, type: u.type })), t);
  function p() {
    var s;
    l.disabled || (a.value ? (e.toggleDisclosure(), (s = d(e.button)) == null || s.focus()) : e.toggleDisclosure());
  }
  function f(s) {
    var m;
    if (!l.disabled) if (a.value) switch (s.key) {
      case v.Space:
      case v.Enter:
        s.preventDefault(), s.stopPropagation(), e.toggleDisclosure(), (m = d(e.button)) == null || m.focus();
        break;
    }
    else switch (s.key) {
      case v.Space:
      case v.Enter:
        s.preventDefault(), s.stopPropagation(), e.toggleDisclosure();
        break;
    }
  }
  function y(s) {
    switch (s.key) {
      case v.Space:
        s.preventDefault();
        break;
    }
  }
  return () => {
    var s;
    let m = { open: e.disclosureState.value === 0 }, { id: x, ...T } = l, K = a.value ? { ref: t, type: n.value, onClick: p, onKeydown: f } : { id: (s = e.buttonId.value) != null ? s : x, ref: t, type: n.value, "aria-expanded": e.disclosureState.value === 0, "aria-controls": e.disclosureState.value === 0 || d(e.panel) ? e.panelId.value : void 0, disabled: l.disabled ? !0 : void 0, onClick: p, onKeydown: f, onKeyup: y };
    return g({ ourProps: K, theirProps: T, slot: m, attrs: u, slots: r, name: "DisclosureButton" });
  };
} }), X = S({ name: "DisclosurePanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(l, { attrs: u, slots: r, expose: o }) {
  let e = O("DisclosurePanel");
  C(() => {
    l.id !== null && (e.panelId.value = l.id);
  }), B(() => {
    e.panelId.value = null;
  }), o({ el: e.panel, $el: e.panel }), k(E, e.panelId);
  let i = L(), a = b(() => i !== null ? (i.value & D.Open) === D.Open : e.disclosureState.value === 0);
  return () => {
    var t;
    let n = { open: e.disclosureState.value === 0, close: e.close }, { id: p, ...f } = l, y = { id: (t = e.panelId.value) != null ? t : p, ref: e.panel };
    return g({ ourProps: y, theirProps: f, slot: n, attrs: u, slots: r, features: h.RenderStrategy | h.Static, visible: a.value, name: "DisclosurePanel" });
  };
} });
export {
  J as Disclosure,
  W as DisclosureButton,
  X as DisclosurePanel
};
